module.exports = __webpack_public_path__ + "img/Lifestyle-low.685408ac.jpg";